module.exports = __webpack_public_path__ + "img/download-file-icon.f6fea2ed.svg";